import React, { FunctionComponent } from "react";

interface Props {
  /** Schriftgrad der Wortmarke in px. */
  size?: number;
  /** Nur der Akzent-Buchstabe — für die eingeklappte Sidebar. */
  compact?: boolean;
  className?: string;
}

/** Wortmarke wie auf webtie.ch: "web" im Akzent, "tie." in der Textfarbe, Inter Black. */
export const WebtieWordmark: FunctionComponent<Props> = ({ size, compact = false, className }) => (
  <span className={`wordmark ${className || ""}`} style={size ? { fontSize: size } : undefined} aria-label="webtie">
    <span className="wordmark__accent">{compact ? "w" : "web"}</span>
    {!compact && <span className="wordmark__text">tie.</span>}
  </span>
);
